<script lang="ts" setup>
const { isMobileView } = useScreen()
const lawyerSearchType = ref('smart_type')

const axios = useAxios()

onMounted(() => {
  lawyerSearchType.value = !isMobileView.value ? 'smart_type' : ''
})

const emit = defineEmits(['update:lawyerSearchType'])

const { state: allSpecialisations } = useAsyncState (
  async () => {
    const specialisationsResponse = await axios.get('/specialisation/by-specialty/lawyer')
    const data = specialisationsResponse.data
    // Ensure we have an array before sorting
    if (!Array.isArray(data)) {
      console.error('Expected array from specialisations API, got:', data)
      return []
    }
    return data.sort((a, b) => a.id - b.id)
  },
  [],
  {
    onError: (error) => console.error(error)
  }
)

function handleSelectLawyerSearchType(newLawyerSearchType: string) {
  lawyerSearchType.value = newLawyerSearchType
  emit('update:lawyerSearchType', newLawyerSearchType)
}
</script>
<template>
  <div v-if="isMobileView" class="flex flex-col gap-4">
    <button
      :class="[
        '*:w-full border border-white items-center justify-center relative rounded-lg py-2.5 font-branding cursor-pointer',
        lawyerSearchType === 'smart_type' ? 'bg-white text-gray-900' : 'bg-none text-white'
      ]" 
      @click="handleSelectLawyerSearchType('smart_type')">
      {{$t('smart_type')}}
    </button>
    <Transition
      enter-active-class="transition-opacity ease-in"
      leave-active-class="transition-opacity ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0 hidden"
    >
    <div v-if="lawyerSearchType === 'smart_type'">
      <div class="pb-1">
        {{ $t('smart_type_info_text') }}
      </div>
      <SmartSearchLawyerBlock :all-specialisations="allSpecialisations"></SmartSearchLawyerBlock>
    </div>
    </Transition>
    <button 
      :class="[
        '*:w-full border border-white items-center justify-center relative transition-all rounded-lg py-2.5 font-branding cursor-pointer',
        lawyerSearchType === 'lawyer_search' ? 'bg-white text-gray-900' : 'bg-transparent text-white'
      ]" 
      @click="handleSelectLawyerSearchType('lawyer_search')">
      {{$t('lawyer_search')}}
    </button>
    <Transition
      enter-active-class="transition-opacity ease-in"
      leave-active-class="transition-opacity ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0 hidden"
    >
      <SearchLawyerBlock v-if="lawyerSearchType === 'lawyer_search'" :all-specialisations="allSpecialisations" />
    </Transition>
  </div>

  <div v-else class="grid gap-2">
    <div class="flex items-center lg:ml-[7%]">
      <GTRadioButton 
        v-model="lawyerSearchType" 
        :options="[
          { id: 'smart_type', label: $t('smart_type') },
          { id: 'lawyer_search', label: $t('lawyer_search') },
          // { id: 'get_lawyers_offer', label: $t('get_lawyers_offer') }
        ]" 
        :dark-theme=false 
        class="*:w-full lg:*:w-[235px] gap-3 flex-col lg:flex-row"
        @change="(event) => handleSelectLawyerSearchType(event.target.value)"
      />
    </div>

    <div v-if="lawyerSearchType === 'smart_type'" class="-py-2">
      {{ $t('smart_type_info_text') }}
    </div>
    
    <div v-if="lawyerSearchType === 'smart_type'">
      <SmartSearchLawyerBlock :all-specialisations="allSpecialisations"></SmartSearchLawyerBlock>
    </div>

    <div v-else-if="lawyerSearchType === 'lawyer_search'" class="bg-gray lg:h-24 rounded-[20px] lg:block">
      <div class="relative flex items-center h-full w-full">
        <SearchLawyerBlock :all-specialisations="allSpecialisations" />
      </div>
    </div>
  </div>
</template>
